import router from '@/router'
import store from '@/store'

import { MetierWsTpu } from 'modulewebservice'
import { MetierLocalStorage } from 'modulelocalstorage'
import QRCode from 'qrcode'

import { version } from '../../package.json'
import i18n from '../lang/index.js'
import {EnumModeCashiers, PaxResultEnum} from '@/modules/Enums'
import { neptingLogout } from '@/modules/Banking'

export class Operations {
  static manageResponse (response, successcallback, errorcallback, carrier = null, forMerchant = false, floatingModeEnabled = false) {
    store.commit('loader', false)

    if (response.OK === 1) {
      if (response.Ticket) {
        router.replace({
          name: 'ticket',
          params: { tickets: [response.Ticket], carrier: carrier, forMerchant: forMerchant, floatingModeEnabled: floatingModeEnabled }
        })
      } else {
        successcallback(response.Display)
      }
    } else {
      errorcallback(response.Msg)
    }
  }

  // ***************************
  // ********** BADGE **********
  // ***************************

  static badgeConsultation (idBadge, carrier, successcallback, errorcallback) {
    store.commit('loader', true)

    MetierWsTpu.callBadgeConsultation(
      MetierLocalStorage.getIdMarchand(),
      MetierLocalStorage.getSession(),
      MetierLocalStorage.getSerial(),
      idBadge
    )
      .then(
        (response) => {
          this.manageResponse(response, successcallback, errorcallback, carrier)
        },
        (e) => {
          store.commit('loader', false)
          errorcallback(e.message)
        }
      )
  }

  static badgeCancellation (idBadge, carrier, successcallback, errorcallback) {
    store.commit('loader', true)
    let cashierID = MetierLocalStorage.getConnectedCashier() ? MetierLocalStorage.getConnectedCashier().id : null
    MetierWsTpu.callBadgeAnnulation(
      MetierLocalStorage.getIdMarchand(),
      MetierLocalStorage.getSession(),
      MetierLocalStorage.getSerial(),
      idBadge,
      null,
      cashierID
    )
      .then(
        (response) => {
          let floatingModeEnabled = store.state.teleparameters.CashierEngagementMode === EnumModeCashiers.FLOATING
          this.manageResponse(response, successcallback, errorcallback, carrier,null, floatingModeEnabled)
        },
        (e) => {
          store.commit('loader', false)
          errorcallback(e.message)
        }
      )
  }

  static badgeDuplicate (idBadge, carrier, successcallback, errorcallback) {
    store.commit('loader', true)

    MetierWsTpu.callBadgeDuplicata(
      MetierLocalStorage.getIdMarchand(),
      MetierLocalStorage.getSession(),
      MetierLocalStorage.getSerial(),
      idBadge
    )
      .then(
        (response) => {
          this.manageResponse(response, successcallback, errorcallback, carrier)
        },
        (e) => {
          store.commit('loader', false)
          errorcallback(e.message)
        }
      )
  }

  static badgeOpposition (idBadge, successcallback, errorcallback) {
    store.commit('loader', i18n.t('loader.opposition'))

    MetierWsTpu.callBadgeOpposition(
      MetierLocalStorage.getIdMarchand(),
      MetierLocalStorage.getSession(),
      MetierLocalStorage.getSerial(),
      idBadge
    )
      .then(
        (response) => {
          store.commit('loader', false)
          if (response.OK) {
            successcallback()
          } else {
            errorcallback(response.message)
          }
        },
        (e) => {
          store.commit('loader', false)
          errorcallback(e.message)
        }
      )
  }

  // ******************************
  // ********** TERMINAL **********
  // ******************************

  static cancellation (successcallback, errorcallback) {
    store.commit('loader', i18n.t('loader.cancelation'))
    let cashierID = MetierLocalStorage.getConnectedCashier() ? MetierLocalStorage.getConnectedCashier().id : null

    MetierWsTpu.callBadgeAnnulation(
      MetierLocalStorage.getIdMarchand(),
      MetierLocalStorage.getSession(),
      MetierLocalStorage.getSerial(),
      null,
      null,
      cashierID
    )
      .then(
        (response) => {
          if (store.state.teleparameters.CashierEngagementMode === EnumModeCashiers.FLOATING) {
            this.manageResponse(response, successcallback, errorcallback, null,false, true)
          } else {
            this.manageResponse(response, successcallback, errorcallback)
          }
        },
        (e) => {
          store.commit('loader', false)
          errorcallback(e.message)
        }
      )
  }

  static duplicate (successcallback, errorcallback) {
    store.commit('loader', i18n.t('loader.duplication'))

    MetierWsTpu.callBadgeDuplicata(
      MetierLocalStorage.getIdMarchand(),
      MetierLocalStorage.getSession(),
      MetierLocalStorage.getSerial()
    )
      .then(
        (response) => {
          this.manageResponse(response, successcallback, errorcallback)
        },
        (e) => {
          store.commit('loader', false)
          errorcallback(e.message)
        }
      )
  }

  static consultation (successcallback, errorcallback) {
    store.commit('loader', i18n.t('loader.consultation'))

    MetierWsTpu.callConsultation(
      MetierLocalStorage.getIdMarchand(),
      MetierLocalStorage.getSession(),
      MetierLocalStorage.getSerial()
    )
      .then(
        (response) => {
          this.manageResponse(response, successcallback, errorcallback, null, true)
        },
        (e) => {
          store.commit('loader', false)
          errorcallback(e.message)
        }
      )
  }

  static telecollection (successcallback, errorcallback) {
    store.commit('loader', i18n.t('loader.tellecolection'))

    MetierWsTpu.callTelecollecte(
      MetierLocalStorage.getIdMarchand(),
      MetierLocalStorage.getSession(),
      MetierLocalStorage.getSerial(),
      version
    )
      .then(
        async (response) => {
          // Si on est connecté à Nepting, on fait un logout
          if (store.getters.neptingToken) {
            await neptingLogout()
          }
          this.manageResponse(response, successcallback, errorcallback, null, true)
        },
        async (e) => {
          // Si on est connecté à Nepting, on fait un logout
          if (store.getters.neptingToken) {
            await neptingLogout()
          }

          store.commit('loader', false)
          errorcallback(e.message)
        }
      )
  }

  // ***********************************
  // ********** PAX / BANKING **********
  // ***********************************

  static formatTransactionsIds (transactions) {
    let ids = ''
    transactions.forEach(transaction => {
      ids += transaction.privateId + ','
      delete transaction.privateId
    })

    return ids === '' ? '' : ids.substring(0, ids.length - 1)
  }

  static getNeptingError (response) {
    if (typeof response === 'string') {
      return response
    }

    let message = 'Opération inconnue'
    let status = parseInt(response.GLOBAL_STATUS)

    switch (status) {
      case PaxResultEnum.Refused:
        message = i18n.t('words.trx.refused')

        if (response.EXTENDED_RESULT && response.EXTENDED_RESULT[0]) {
          message += ` (${response.EXTENDED_RESULT}) `
          switch (response.EXTENDED_RESULT[0]) {
            case PaxResultEnum.Canceled:
              message += '\n\n' + (response.MESSAGE_TYPE ? response.MESSAGE_TYPE : i18n.t('words.payment')) + ' ' + i18n.t('words.cancelled')
              break
            case PaxResultEnum.Ripped:
              message += '\n\n' + i18n.t('words.ripped_card')
              break
            case PaxResultEnum.Payment:
              message += '\n\n' + (response.MESSAGE_TYPE ? response.MESSAGE_TYPE : i18n.t('words.payment')) + ' ' + i18n.t('words.cancelled')
              break
          }
        }
        break
      case PaxResultEnum.Aborted:
        message = i18n.t('words.trx.cancelled')
        break
      case PaxResultEnum.Error:
        message = i18n.t('words.trx.error')
        break
    }
    return message
  }

  static sendOfflineTransactions () {
    return new Promise((resolve, reject) => {
      CashlessTransaction.getTransactions(transactions => {
        if (transactions.length > 0) {
          const ids = this.formatTransactionsIds(transactions)

          MetierWsTpu.callTransactionOffline(
            MetierLocalStorage.getIdMarchand(),
            MetierLocalStorage.getSession(),
            transactions
          ).then(
            response => {
              if (response.OK === 1) {
                CashlessTransaction.deleteTransactions({ ids: ids })
                resolve(transactions.length)
              } else {
                reject(response.Msg ? response.Msg : response.message)
              }
            },
            err => {
              reject(err)
            }
          )
        } else {
          resolve(0)
        }
      })
    })
  }

  static sendPourboireTransactions () {
    return new Promise((resolve, reject) => {
      Tip.getTransactions(transactions => {
        if (transactions.length > 0) {
          const ids = this.formatTransactionsIds(transactions)

          MetierWsTpu.callTransactionsPourboire(
            MetierLocalStorage.getIdMarchand(),
            MetierLocalStorage.getSession(),
            MetierLocalStorage.getSerial(),
            transactions
          ).then(
            response => {
              if (response.OK === 1) {
                Tip.deleteTransactions({ ids: ids })
                resolve(transactions.length)
              } else {
                reject(response.Msg ? response.Msg : response.message)
              }
            },
            err => {
              reject(err)
            }
          )
        } else {
          resolve(0)
        }
      })
    })
  }

  static sendDonTransactions () {
    return new Promise((resolve, reject) => {
      Donation.getTransactions(transactions => {
        if (transactions.length > 0) {
          const ids = this.formatTransactionsIds(transactions)

          MetierWsTpu.callTransactionsDon(
            MetierLocalStorage.getIdMarchand(),
            MetierLocalStorage.getSession(),
            MetierLocalStorage.getSerial(),
            transactions
          ).then(
            response => {
              if (response.OK === 1) {
                Donation.deleteTransactions({ ids: ids })
                resolve(transactions.length)
              } else {
                reject(response.Msg ? response.Msg : response.message)
              }
            },
            err => {
              reject(err)
            }
          )
        } else {
          resolve(0)
        }
      })
    })
  }

  static sendBankingTransactions () {
    return new Promise((resolve, reject) => {
      Banking.getTransactions(transactions => {
        if (transactions.length > 0) {
          const ids = this.formatTransactionsIds(transactions)

          MetierWsTpu.callTransactionsEnvoi(
            MetierLocalStorage.getIdMarchand(),
            MetierLocalStorage.getSession(),
            MetierLocalStorage.getSerial(),
            transactions
          ).then(
            response => {
              if (response.OK === 1) {
                Banking.deleteTransactions({ ids: ids })
                resolve(transactions.length)
              } else {
                reject(response.Msg ? response.Msg : response.message)
              }
            },
            err => {
              reject(err)
            }
          )
        } else {
          resolve(0)
        }
      })
    })
  }

  static async getAllW2STransactions () {
    store.commit('loader', i18n.t('loader.transactions_search'))

    return new Promise((resolve, reject) => {
      MetierWsTpu.callTransactionsW2SListe(
        MetierLocalStorage.getIdMarchand(),
        MetierLocalStorage.getSession(),
        MetierLocalStorage.getSerial(),
      ).then(
        response => {
          store.commit('loader', false)
          if (response.OK === 1) {
            resolve(response.Transactions)
          } else {
            reject(response.Msg ? response.Msg : response.message)
          }
        },
        err => {
          store.commit('loader', false)
          reject(err)
        }
      )
    })
  }
}

export function dpaPayment (errorcallback) {
  store.commit('loader', i18n.t('loader.dpa'))

  MetierWsTpu.callDpaPayment(
    MetierLocalStorage.getIdMarchand(),
    MetierLocalStorage.getSession(),
    store.state.amount
  )
    .then(
      (response) => {
        store.commit('loader', false)
        if (response.OK) {
          QRCode.toDataURL(response.link, { scale: 8, errorCorrectionLevel: 'H' }).then(result => {
            router.replace({
              name: 'ticket',
              params: { tickets: [{
                  Image: result.replace('data:image/png;base64,', ''),
                  isPNG: true,
                  Lignes: []
                }]
              }
            })
          })
        } else {
          errorcallback(response.Msg)
        }
      },
      (e) => {
        store.commit('loader', false)
        errorcallback(e.message)
      }
    )
}
